import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Waypoint } from "react-waypoint";
import EncabezadoComponent from "../../utilerias/encabezado";
import LightboxComponent from "../lightbox";
import $ from "jquery";
import "./styles.css";

const Carousel = (props) => {
  const [lightOpen, guardarLigthOpen] = useState(false);
  const [lightOpenPosicion, guardarLigthOpenPosicion] = useState(0);
  const equipoImagenes = props.imagenes;

  const handleWaypointEnter = (idImg) => {
    const imgGaleria = document.getElementById(idImg);

    const verContenedor = document.getElementById("contenedor-ver-" + idImg);
    const verIcono = document.getElementById("ver-galeria-" + idImg);
    const distorcion = document.getElementById(
      "galeria-box-distorcion-" + idImg
    );

    if (imgGaleria) {
      const x = window.matchMedia("(max-width: 999px)");
      if (x.matches === true) {
        distorcion.style.width = "80vw";
        distorcion.style.height = "50vh";

        imgGaleria.style.height = "50vh";
        imgGaleria.style.width = "80vw";
        setTimeout(function () {
          imgGaleria.style.opacity = "1";
        }, 1000);

        verIcono.style.height = "50vh";
        verIcono.style.width = "80vw";

        setTimeout(function () {
          distorcion.style.opacity = "0";
        }, 1200);
      } else {
        imgGaleria.style.height = "50vh";
        imgGaleria.style.width = "20vw";
        setTimeout(function () {
          imgGaleria.style.opacity = "1";
        }, 1000);

        verContenedor.style.visibility = "visible";

        verIcono.style.height = "50vh";
        verIcono.style.width = "20vw";

        distorcion.style.width = "20vw";
        distorcion.style.height = "50vh";
        distorcion.style.transition = "0.8s";
        setTimeout(function () {
          distorcion.style.opacity = "0";
        }, 1200);
      }
    }
  };

  useEffect(() => {
    investirScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const lightbox = (id) => {
    if (lightOpen) {
      guardarLigthOpen(false);
    } else {
      guardarLigthOpenPosicion(id);
      guardarLigthOpen(true);
    }
  };

  const investirScroll = () => {
    const scroller = {};
    const x = window.matchMedia("(min-width: 1000px)");
    if (x.matches === true) {
      scroller.e = document.getElementById("invertir-scroll");

      if (scroller.e.addEventListener) {
        scroller.e.addEventListener("mousewheel", MouseWheelHandler, false);
        scroller.e.addEventListener("DOMMouseScroll", MouseWheelHandler, false);
      } else scroller.e.attachEvent("onmousewheel", MouseWheelHandler);

      function MouseWheelHandler(e) {
        // cross-browser wheel delta
        const sc = window.event || e;
        const delta =
          -500 * Math.max(-1, Math.min(1, sc.wheelDelta || -sc.detail));

        let pst = $("#invertir-scroll").scrollLeft() + delta;
        if (pst < 0) {
          pst = 0;
        } else if (pst > $("#slider-galeria").width()) {
          pst = $("#slider-galeria").width();
        }

        $("#invertir-scroll").scrollLeft(pst);

        return false;
      }
    }
  };

  return (
    <Fragment>
      <Container
        id="invertir-scroll"
        fluid
        className="contenedor-principal-galeria"
      >
        <Row>
          <Col className="galeria-encabezado" md={12} lg={12} align="center">
            <EncabezadoComponent
              componente={props.componente}
              select={false}
            ></EncabezadoComponent>
          </Col>
        </Row>
        <div className="lightbox-contenedor">
          <LightboxComponent
            lightbox={lightbox}
            isOpen={lightOpen}
            imgLightbox={equipoImagenes}
            lightOpenPosicion={lightOpenPosicion}
          ></LightboxComponent>
        </div>
        <div id="slider-galeria">
          {props.imagenes.map((index, i) => {
            return (
              <Fragment key={i}>
                <div className="galeria-contenedor-scroll">
                  <Waypoint
                    onEnter={() => handleWaypointEnter(i + 1)}
                    horizontal={true}
                  />
                  <div className="content-galeria">
                    <div id={i + 1} className="bordes scroll-img-contenedor">
                      <img src={props.imagenes[i].imagen} alt="" />
                    </div>
                  </div>
                  <div
                    className="ver-img-galeria"
                    onClick={() => lightbox(i + 1)}
                    id={"ver-galeria-" + (i + 1)}
                  >
                    <div
                      id={"contenedor-ver-" + (i + 1)}
                      className="contenedor-ver-mas"
                    >
                      +
                    </div>
                    <div className="galeria-imagen-distoricionada">
                      <div
                        id={"galeria-box-distorcion-" + (i + 1)}
                        className="galeria-box-distorcion"
                      >
                        <Image
                          className="galeria-img-distorcion"
                          src="/assets/servicios/gris.gif"
                          onClick={() => lightbox(i + 1)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Fragment>
            );
          })}
        </div>
      </Container>
    </Fragment>
  );
};

Carousel.propTypes = {
  imagenes: PropTypes.array,
  componente: PropTypes.string,
};

export default Carousel;
